import React from 'react';
import { AlertTriangle, PackageX, Clock, ChevronRight } from 'lucide-react';
import './FleetCriticalBar.css';

// kind: 1=HazırAlınmadı, 2=SözAşıldı, 3=AtanamadıBekliyor (DelayReminderKind)
const KIND = {
    3: { label: 'atanmadı', tone: 'danger' },
    1: { label: 'hazır • alınmadı', tone: 'warn' },
    2: { label: 'gecikti', tone: 'warn' },
};

// Tüm sayfaların üstünde kalıcı kritik-paket uyarı barı. Boşsa hiç render etme.
const FleetCriticalBar = ({ summary, onNavigate }) => {
    if (!summary || (summary.totalCritical || 0) === 0) return null;

    const { unassignedCount = 0, overdueCount = 0, items = [] } = summary;
    const go = () => onNavigate && onNavigate('deliveries');

    return (
        <div className="fcb" role="button" tabIndex={0} onClick={go}
             onKeyDown={(e) => { if (e.key === 'Enter') go(); }}>
            <div className="fcb-head">
                <AlertTriangle size={16} className="fcb-icon" />
                <span className="fcb-title">Kritik Paketler</span>
                {unassignedCount > 0 && (
                    <span className="fcb-count danger"><PackageX size={12} /> {unassignedCount} atanmamış</span>
                )}
                {overdueCount > 0 && (
                    <span className="fcb-count warn"><Clock size={12} /> {overdueCount} gecikmiş</span>
                )}
                <span className="fcb-cta">Teslimatlar <ChevronRight size={14} /></span>
            </div>
            <div className="fcb-items">
                {items.slice(0, 8).map((it) => {
                    const k = KIND[it.kind] || KIND[2];
                    return (
                        <span key={it.id} className={`fcb-chip ${k.tone}`}>
                            <strong>{it.internalOrderNumber || it.externalOrderId || '—'}</strong>
                            {it.partnerName && <span className="fcb-chip-partner">{it.partnerName}</span>}
                            <span className="fcb-chip-kind">{k.label} • {it.minutesLate} dk</span>
                        </span>
                    );
                })}
                {items.length > 8 && <span className="fcb-more">+{items.length - 8} daha</span>}
            </div>
        </div>
    );
};

export default FleetCriticalBar;
